import React from 'react';
import Lottie from 'lottie-react';
import loadingAiAnimation from '../animations/ai-animation.json'; // Existing loading animation
import emptyAnimation from '../animations/empty-animation.json'; // Placeholder for empty state animation

export function LoadingGeminiState() {
    return (
        <div className="loading-container">
            <div style={{ width: '250px', margin: '0 auto' }}>
                <Lottie animationData={loadingAiAnimation} loop={true} />
            </div>
            <h3 style={{ paddingTop: '16px' }}>Menganalisa Berita...</h3>
            <p>Sedang menganalisa berita dengan Gemini AI ✨</p>
        </div>
    );
}

export function EmptyState() {
    return (
        <div className="empty-state">
            <div style={{ width: '250px', margin: '0 auto' }}>
                <Lottie animationData={emptyAnimation} loop={true} />
            </div>
            <h3>Gagal menganalisis berita</h3>
            <p>Silakan coba muat ulang atau periksa koneksi internet Anda.</p>
        </div>
    );
}